// extracted by mini-css-extract-plugin
export default {"cls1":"NewsHeader-cls1___4a6fc876216d3d63dba","cls2":"NewsHeader-cls2___dc71c6c137c6e2bdbda NewsHeader-cls1___4a6fc876216d3d63dba"};